export default {
  main: {
    hero: `
        歡迎進入<br/>
        <strong>生動有趣的</strong>遊戲世界，<br/>
        與<strong>魅力無限的</strong>角色<br/>
        盡情玩樂
      `,
    homescapes: `Scapes™ 系列的超人氣作品，玩家可以在遊戲中與管家奧斯汀一起修復美麗豪宅`,
    township: `有趣好玩的城市建設遊戲，充滿精彩活動、刺激比賽和玩家對戰錦標賽`,
  },
  common: {
    login: '登入',
    logout: '登出',
    support: '支援',
    privacy: '隱私權政策',
    terms: `服務條款`,
    and: '還有',
    guest: '客人',
    play: '開始遊戲',
    install: '安裝',
  },
  support: {
    title: `需要支援嗎？`,
    description: `如果您是這款遊戲的使用者，而且遇到了困難，
      我們會很樂意提供幫助並解答所有疑問。`,
    button: '@:common.support',
  },
  homescapes: {
    title: '夢幻家園',
    caption: '幫助管家奧斯汀將溫暖和舒適帶回他家的豪宅。',
    description: `幫助管家奧斯汀將溫暖和舒適帶回
      他家的豪宅。一起來吧，冒險
      在踏進門的時刻就將開始！`,
    xsolla: 'Xsolla 公司是《夢幻家園》遊戲授權的全球經銷商',
    install: {
      title: '@:common.install',
      text: `在桌面上暢玩《夢幻家園》！
      安裝遊戲的網路版本，只需點擊幾下即可探訪奧斯汀！`,
      button: '@:common.install',
    },
  },
  township: {
    title: '夢想小鎮',
    caption: `快來打造你的夢想小鎮！收割作物、在工廠處理作物，
      然後將商品賣出去，發展欣欣向榮的小鎮。`,
    description: `快來打造你的夢想小鎮！收割作物、在工廠處理作物，
      然後將商品賣出去，發展欣欣向榮的小鎮。`,
    xsolla: 'Xsolla 公司是《夢想小鎮》遊戲授權的全球經銷商',
    install: {
      title: '@:common.install',
      text: `在桌面上玩《夢幻小鎮》！
      安裝網頁版遊戲，只需點擊幾下即可造訪您的城鎮！`,
      button: '@:common.install',
    },
  },
  cookie: {
    message: '這一網站使用信息記錄程序以確保您獲得最佳體驗',
    link: `更多資訊`,
    button: '接受',
  },
  game: {
    notSupported: `不支持移動裝置。請用電腦登入進行遊戲。`,
  },
};
